import { Province, StreetType } from '@models/address';

export const REGISTER_PORTAL_ID = "11";
export const REGISTER_ENTITY_ID = "00";
export const REGISTER_GROUP_CODE = "0";
export const REGISTER_PIN_SMS_ID = 'mets-register-sms';
export const APP_KEY_PIN_SMS = 'DigitalUser';
export const CAMPAIGN_DESC_DEFAULT = 'REGISTRO ONLINE';
export const RegisterGenderOptions = {
  MALE: 1,
  FEMALE: 2
};

export const RegisterDocumentTypeOptions = {
  NIF: 0,
  NIE: 2
};

export interface RegisterState {
  campaingId: string;
  campaignDesc: string;
  documentType: string;
  documentNumber: string;
  email: string;
  emailRes: string;
  confirmEmail: string;
  password: string;
  phone: string;
  phoneRes: string;
  initAuth: 'PHONE' | 'EMAIL';
  secondAuth: boolean;
  OTPCodePhone: string;
  OTPCodeEmail: string;
  name: string;
  lastname1: string;
  lastname2: string;
  lastnames: string;
  birthdate: Date;
  gender: string;
  postalCode: string;
  province: string;
  provinces: Province[];
  locality: string;
  streetType: string;
  streetTypes: StreetType[];
  street: string;
  streetNumber: string;
  doorway: string;
  stairs: string;
  floor: string;
  door: string;
  IBAN: string;
  addressComplement: string;
  teCuidamos: boolean;
  MtC: boolean;
  serviceConditions: boolean;
  privacyPolicies: boolean;
  rgpdue: boolean;
  receiveInfo: boolean;
  onlineCampaign: boolean;
  userHash: boolean;
  validatedEmail: boolean;
  validEmail: boolean;
  queryParamsChecked: boolean;
  srv: string;
  businessId: string;
  token: string;
  tokenValidation: string;
  pinToken: string;
  pinEmailToken: string;
  roStarted: boolean;
  hashTC: string;
  address: string;
  hasHealthPolicies: 'S' | 'N';
  mcaOnboarding: boolean;
  channel: string;
  subchannel: string;
  checkEmail: boolean;
  clientDuplicateAuth: boolean;
  checkIban: boolean;
}
export interface RegisterUserHttpResponse {
  campaignDesc: string;
  status: string | number;
  error: string;
  errorCode: string;
  documentNumber: string;
  documentType: string;
  email: string;
  mobile: string;
  mobilePhone: string;
  name: string;
  birthDate: string;
  surname1: string;
  surname2: string;
  gender: string;
  teCuidamos: 'S' | 'N';
  hasHealthPolicies: 'S' | 'N';
  token: string,
  address: Partial<{
    city: string;
    door: string;
    floor: string;
    number: string;
    portal: string;
    postalCode: string;
    province: string;
    stair: string;
    street: string;
    streetType: string;
  }>;
}

export enum RegisterUrls {
  COOKIES_POLICY = 'http://www.mapfre.es/seguros/privacidad/politica-de-cookies.jsp',
  PRIVACY_POLICY = 'https://www.mapfre.es/seguros/privacidad/privacidad-area-cliente.jsp',
  SERVICE_CONDITIONS = 'https://www.mapfretecuidamos.com/media/condiciones_generales.pdf',
  TECUIDAMOS_PRIVACITY = 'https://www.mapfretecuidamos.com/media/privacidad.pdf',
  TECUIDAMOS_CONDITIONS = 'https://www.mapfretecuidamos.com/media/condiciones_generales.pdf'
}

export enum ValidateOnlineCampaignUserResponseCodes {
  OK = '200401',
  UNIDENTIFIED_CUSTOMER = '200402',
}

export enum InitialDataValidatonResponseCodes {
  OK = '200101',
  CUSTOMER_ALREADY_REGISTERED = '200102',
  NO_CLIENT_PROFILE = '200103',
  INCOMING_CALL1 = '200104',
  INCOMING_CALL2 = '200108',
  MORE_NECESSARY_DATA = '200109',
  CLIENT_DUPLICATE = '200110',
  CLIENT_NOT_FOUND = '200111',
  WRONG_PHONE_FORMAT = '400002',
  WRONG_PAYLOAD1 = '400001',
}

export enum RegisterUserResponseCodes {
  OK = '200301',
  ONLINE_REGISTRATION_MADE = '200302',
  CHANGE_USER_STATUS_ERROR = '500304',
  CUSTOMER_ALREADY_REGISTERED = '500303',
  REGISTER_ERROR1 = '500000',
  REGISTER_ERROR2 = '500301',
  REGISTER_ERROR3 = '500302',
  REGISTER_ERROR4 = '500305',
  REGISTER_ERROR5 = '500306',
  CUSTOMER_CANCELLED = '500307',
  WRONG_PAYLOAD1 = '400001',
  WRONG_PAYLOAD2 = '400002',
  WRONG_PHONE_FORMAT = '400003',
  BIRTHDATE_NOT_ACCEPTABLE = '406301'

}

export enum RegisterRouting {
  HOME = 'client-area/home',
  BASE_PATH = 'register/',
  INITIAL_DATA = 'initial-data',
  RGPDUE = 'rgpdue',
  RGPDUE_DETAIL = 'rgpdue-detail',
  CLIENT_DUPLICATE_DATA = 'validate-client-duplicate-data',
  VALIDATE_EMAIL = 'validate-email',
  VALIDATE_PHONE = 'validate-phone',
  BIRTHDATE = 'birthdate',
  SECURITY_PHONE_CODE = 'security-sms-code',
  SECURITY_EMAIL_CODE = 'security-email-code',
  VALIDATE_IBAN = 'validate-iban',
  VALIDATE_CONTACT_DATA = 'validate-contact-data',
  CREATE_PASSWORD = 'create-password',
  SECURITY_QUESTION = 'security-question',
  SECURITY_QUESTION_LIST = 'security-question-list',
  TECUIDAMOS_JOIN = 'tecuidamos-join',
  TECUIDAMOS_CONTACT_DATA = 'tecuidamos-contact-data',
  TECUIDAMOS_PRIVACY_POLICIES = 'tecuidamos-privacy-policies',
  RESULT = 'result',
  JOIN_MTC = 'tecuidamos-join'
}

export const RegisterControlNames = {
  INITIAL_DATA: ['documentType', 'documentNumber'],
  RGPDUE: ['receiveInfo', 'rgpdue'],
  SECURITY_PHONE_CODE: ['OTPCodePhone'],
  SECURITY_EMAIL_CODE: ['OTPCodeEmail'],
  VALIDATE_EMAIL: ['email'],
  BIRTHDATE: ['birthdate'],
  VALIDATE_PHONE: ['phone'],
  VALIDATE_IBAN: ['IBAN'],
  CLIENT_DUPLICATE_DATA: ['name', 'lastname1', 'lastname2'],
  TECUIDAMOS_CONTACT_DATA: [
    'birthdate',
    'postalCode',
    'province',
    'locality',
    'streetType',
    'street',
    'streetNumber',
    'doorway',
    'stairs',
    'floor',
    'door',
    'addressComplement',
    'email',
    'phone',
    'gender',
    'privacyPolicies',
  ],
  VALIDATE_CONTACT_DATA: [
    'name',
    'lastname1',
    'lastname2',
    'birthdate',
    'gender',
    'email',
    'phone',
    'postalCode',
    'province',
    'locality',
    'streetType',
    'street',
    'streetNumber',
    'doorway',
    'stairs',
    'floor',
    'door',
    'addressComplement'
  ],
  CREATE_PASSWORD: ['password', 'serviceConditions'],
  SECURITY_QUESTION: ['securityQuestion', 'ownSecurityQuestion', 'securityAnswer'],
  JOIN_MTC: ['MtC'],
  TECUIDAMOS_PRIVACY_POLICIES: ['serviceConditions', 'privacyPolicies'],
};

export enum RegisterLoadingId {
  LOAD_CONTACT_DATA = 'load-contact-data',
  USER_DATA_ONBOARDING = 'user-data-onboarding',
  GET_USER_DATA_ONBOARDING = 'get-user-data-onboarding',
  VALIDATE_EMAIL = 'validate-email',
  INCOMING_CALL = 'incoming_call',
  VALIDATE_INITIAL_DATA = 'validate-email',
  SECURITY_QUESTIONS = 'security-questions',
  DECYPHER_HASH = 'decypher-hash',
  ONLINE_CAMPAIGN = 'online-campaign',
  SEND_REQUEST = 'send-request',
  LOGIN = 'login',
  DOWNLOAD_PDF = 'download-pdf',
  GET_PIN = 'get-pin',
  VALIDATE_PIN = 'validate-pin',
}

export enum RegisterApiPath {
  EMAIL = 'clientsArea/clients/validation/email',
  INCOMING_CALL = 'clientsArea/clients/applicationRegistry/incomingCall',
  USER = 'clientsArea/clients/validation/user',
  QUESTIONS = 'clientsArea/clients/user/questions',
  CAMPAIGN_ID = 'campaign/[ID]/description',
  HASH = 'clientsArea/clients/user/hash/',
  LOGIN = '/jwt/login',
}

export enum RegisterQueryParams {
  HASH = 'hashTC',
  SRV = 'srv',
  CHANNEL = 'channel',
  SUBCHANNEL = 'subChannel',
  SUBCHANNEL_LOWER = 'subchannel',
}

export enum RegisterServiceCodes {
  APP = '11',
  WEB = '22'
}

export type RegisterQueryParamsTypes = keyof typeof RegisterQueryParams;

export interface RegisterResponse {
  status: number | string;
  code: string;
  message?: string;
  address?: {
    city?: string;
    door?: string;
    floor?: string;
    number?: string;
    portal?: string;
    postalCode?: string;
    province?: string;
    stair?: string;
    street?: string;
    streetType?: string;
  };
  birthDate?: string;
  gender?: string;
  name?: string;
  surname1?: string;
  surname2?: string;
  teCuidamos?: 'S' | 'N';
  isPolicyHolder?: 'S' | 'N';
  isDuplicateRicClient?: 'S' | 'N';
  fechaNacimientoRic?: string;
  iban?: 'S' | 'N';
  otp?: string;
  hasHealthPolicies?: 'S' | 'N';
  onlyOfflineProducts?: 'S' | 'N';
  token?: string;
}

export interface ValidateEmailResponse {
  validEmail?: 'S' | 'N' | boolean;
  status?: number;
  disablingCode: string;
}

export interface GetPinEmailRequest {
  userName: string;
  email: string;
}

export interface RegisterValidatePinSMSResponse {
  businessId: string;
  token: string;
  status: number;
}
export interface RegisterValidatePinEmailResponse {
  code: string;
  token: string;
  message: number;
  valid: string;
  status: number;
}

export interface RegisterAttempts {
  value: number;
}

export interface RegisterRicProfileRequest {
  name: string;
  surname1: string;
  surname2: string;
}

export interface RegisterIbanRequest {
  numeroIban: string;
  numeroIntento: string;
}

export interface RegisterMatchCode {
  value: boolean;
}

export interface MapfreClubData {
  TITLE: string;
  RESPONSABLE: string;
  MAPFRE_CLUB: string;
  FINALITY: string;
  FINALITY_TEXT: string;
  RIGHTS: string;
  URL: string;
}

export enum RegisterPages {
  INITIAL_DATA = 'Pantalla datos iniciales usuario',
  RGPDUE = 'Pantalla protección de datos',
  VALIDATE_PHONE = 'Pantalla validar teléfono',
  SECURITY_PHONE_CODE = 'Pantalla validar código sms',
  SECURITY_EMAIL_CODE = 'Pantalla validar código email',
  BIRTHDATE = 'Pantalla fecha de nacimiento',
  VALIDATE_IBAN = 'Pantalla IBAN',
  VALIDATE_CONTACT_DATA = 'Pantalla completar datos usuario',
  CREATE_PASSWORD = 'Pantalla crear password',
  SECURITY_QUESTION = 'Pantalla preguntas de seguridad',
  SECURITY_QUESTION_DETAIL = 'Pantalla preguntas de seguridad detalle',
  TECUIDAMOS_PRIVACY_POLICIES = 'Pantalla Mapfre te cuidamos',
}

export interface AddressUserDataResponse {
  city: string;
  number: string;
  postalCode: string;
  province: string;
  street: string;
  streetDescription: string;
  streetType: string;
  doorway?: string;
  stairs?: string;
  floor?: string;
  door?: string;
  addressComplement?: string;
}

export interface PostUserDataResponse {
  status: number | string;
}

export interface GetUserDataResponse {
  address: AddressUserDataResponse;
  birthdate: string;
  contractAcceptanceDate: string;
  documentNumber: string;
  documentType: string;
  email: string;
  lastname: string;
  lastname2: string,
  mcaOnboarding: string;
  name: string;
  phones: string[];
  securityQuestion: string;
  signingKeyLastModified: string;
  signingKeyStatus: string;
  signingKeyStatusDescription: string;
  status: string;
  treatment: string;
  streetTypes?: StreetType[];
  provinces?: Province[];
  password?: string;
  token?: string;
  hasLoggedIn?: boolean,
  hasHealthProducts: 'S' | 'N';
}

export interface OnBoardingData extends Partial<GetUserDataResponse> {
  user: GetUserDataResponse;
}

interface ResultRegisterButton {
  text: string;
  src?: string;
  show?: boolean;
  icon?: string;
  slot?: 'end' | 'start';
  onClick?: Function;
  class?: string;
  state?: any;
  type?: 'primary' | 'dark' | 'clear' | 'link';
}

export interface ResultRegisterButtons {
  primary: ResultRegisterButton,
  secondary: ResultRegisterButton,
  buttonsDownloadApp: boolean,
  reverse: boolean;
}

export interface ResultRegisterInput {
  label?: string,
  value?: string,
  button?: {
    type: 'primary' | 'dark' | 'clear' | 'link' | 'borderD';
    title?: string,
    onClick?: () => void;
  };
}

export interface ResultRegisterOptions {
  data: {
    titleHi?: string;
    title?: string;
    message?: string;
    infoCall?: boolean;
    infoCallMessage?: string;
    imgDesktop?: string;
    imgMobile?: string;
    inputs?: ResultRegisterInput[];
    infoDesktop?: boolean;
    errMtC?: string;
  },
  buttons: Partial<ResultRegisterButtons>;
}

export enum RegisterErrors {
  WAIT_FEW_MINUTOS_PIN_SMS = '302',
}

